import { addEventListener as addNetInfoListener } from "@react-native-community/netinfo";
import { focusManager, onlineManager, QueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { AppState, type AppStateStatus, Platform } from "react-native";

const MINUTE = 60_000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 30 * MINUTE,
      retry: 1,
      staleTime: 2 * MINUTE,
    },
  },
});

// Native only. On web, React Query already tracks the browser's online and offline events and
// starts each page load as online, so a query can fetch, fail and surface a real error. NetInfo
// reports `navigator.onLine` immediately, which would pause queries before the first fetch; a query
// that never errors never reaches its fallback, so the public Show's offline snapshot
// (`usePublicShow`) would spin instead of restoring from CacheStorage.
if (Platform.OS !== "web") {
  onlineManager.setEventListener((setOnline) =>
    addNetInfoListener((state) => setOnline(state.isConnected ?? true))
  );
}

function onAppStateChange(status: AppStateStatus) {
  if (Platform.OS !== "web") focusManager.setFocused(status === "active");
}

export function useQueryAppState() {
  useEffect(() => {
    if (Platform.OS === "web") return undefined;
    const subscription = AppState.addEventListener("change", onAppStateChange);
    return () => subscription.remove();
  }, []);
}
